import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

import { CardType } from 'services/checkout-service/models';
import { getIconNameForCardType, getTranslatedCardTypeName } from 'utils/PaymentCard';
import { Icon } from 'components/Icon';

import { CONFIRMATION_TEST_IDS } from '../const';

import styles from './styles.module.scss';

type PaymentSourceInfoProps = {
  cardType?: CardType;
  lastFour?: string;
  paymentMethodDetails?: string;
};

const makeCardInfo = ( cardType: CardType, lastFour: string) => (
  <>
    <Icon
      data-testid={CONFIRMATION_TEST_IDS.cardBrandIcon}
      className={styles.brandIcon}
      name={getIconNameForCardType(cardType)}
    />
    <span
      data-testid={CONFIRMATION_TEST_IDS.cardBrandName}
      className={styles.cardBrand}
    >
      {getTranslatedCardTypeName(cardType)}
    </span>
    <span data-testid={CONFIRMATION_TEST_IDS.lastFour}>{lastFour}</span>
  </>
);

const makeAchInfo = (t: TFunction, lastFour: string) => (
  <span data-testid={CONFIRMATION_TEST_IDS.achLastFour}>{t('common:ach.tender', { lastFour })}</span>
);

export const PaymentSourceInfo: FC<PaymentSourceInfoProps> = ({ cardType, lastFour, paymentMethodDetails }) => {
  const { t } = useTranslation();

  // Both card and ach payments must have a last 4
  if (!lastFour) return null;

  const isAch = paymentMethodDetails === 'ach';

  return (
    <div data-testid={CONFIRMATION_TEST_IDS.paymentSource} className={styles.payInfo}>
      {cardType && !isAch && makeCardInfo(cardType, lastFour)}
      {isAch && makeAchInfo(t, lastFour)}
    </div>
  );
};
